// PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION
const isMoreThanFourPerRoom = (roomCount: number, guestCount: number) => {
  return roomCount === 1 && guestCount > 4
}

export default isMoreThanFourPerRoom
